(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/error-boundary/error-boundary.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/error-boundary/error-boundary.js');
"use strict";

const _React = React,
  Component = _React.Component;
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(
  ) {
  }
  render() {
    const _this$props = this.props,
      errorComponent = _this$props.errorComponent,
      children = _this$props.children;
    const hasError = this.state.hasError;
    if (hasError) {
      return errorComponent || React.createElement("h2", null, "N\xE5got har g\xE5tt tokigt h\xE4r..");
    }
    return children;
  }
}
svs.ticket_partner.sharedComponents.errorBoundary.ErrorBoundary = ErrorBoundary;

 })(window);